import React from 'react'
import {connect} from 'react-redux'
import {segmentMatchSelectors} from 'data/resources/segmentMatches'
import {Distance, Duration, Elevation, Grade, Speed} from 'common/units'
import {FullBleedList} from 'features/routes/RouteShowPage/SidePanel/FullBleedList'
import styles from './TRouteSegments.scss'
import {TrackLocation} from 'data/records'
import {featureTypes} from 'common/MapV2/featureTypes'
import cx from 'classnames'

const SegmentMatch = ({match, onMouseOver, onMouseOut, onClick}) => {
  return <li
    className={styles.segmentMatch}
    onMouseOver={() => onMouseOver(match)}
    onClick={() => onClick(match)}
    onMouseOut={onMouseOut}>
    <a className={styles.title} href={`/segments/${match.segmentId}`}>{match.segmentTitle}</a>
    <div className={styles.grid}>
      <div className={cx(styles.column, styles.left)}>
        <Distance short value={match.distance} bigUnits />
        <span className={cx(match.personalRecord && styles.pr)}><Duration biggestUnits valueOnly value={match.duration} /></span>
      </div>
      <div className={cx(styles.column, styles.middle)}>
        <span className={styles.eleGain}><Elevation short value={match.eleGain} /></span>
        <span className={cx(match.personalRecord && styles.pr)}><Speed short value={match.avgSpeed} bigUnits /></span>
      </div>
      <div className={cx(styles.column, styles.right)}>
        <Grade short value={match.grade || 0} bigUnits />
        <span className={cx(match.personalRecord && styles.pr)}>{match.personalRecord && `#${match.rank}`}</span>
      </div>
    </div>
  </li>
}

class _TRouteSegments extends React.PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  toggleExpanded = () => this.setState({expanded: !this.state.expanded})

  onMouseOver = (segmentMatch) => {
    const {onFeatureHovered} = this.props
    const highlightSlice = [
      TrackLocation({left: segmentMatch.startIndex, pct: 0}),
      TrackLocation({left: segmentMatch.endIndex, pct: 0})
    ]
    onFeatureHovered({
      type: featureTypes.SEGMENT_MATCH,
      data: {highlightSlice, segmentMatch}
    })
  }

  onClick = (segmentMatch) => {
    const {onFeatureSelected} = this.props
    const highlightSlice = [
      TrackLocation({left: segmentMatch.startIndex, pct: 0}),
      TrackLocation({left: segmentMatch.endIndex, pct: 0})
    ]
    onFeatureSelected({
      type: featureTypes.SEGMENT_MATCH,
      data: {highlightSlice, segmentMatch}
    })
  }

  onMouseOut = () => {
    const {onFeatureHovered} = this.props
    onFeatureHovered(null) // why does this inst-nerf the segment?
  }

  render () {
    const {segmentMatches, objectType} = this.props
    const {expanded} = this.state

    if (!segmentMatches || segmentMatches.size === 0) {
      return null
    }

    const toShow = expanded
      ? segmentMatches.toIndexedSeq()
      : segmentMatches.toIndexedSeq().slice(0, 3)

    return (
      <div className={styles.TRouteSegments}>
        <h2>Segments</h2>
        {segmentMatches.size > 0 && <FullBleedList interactive>
          {toShow.map(sm => <SegmentMatch
            key={sm.id}
            match={sm}
            onMouseOver={this.onMouseOver}
            onMouseOut={this.onMouseOut}
            onClick={this.onClick} />)}
        </FullBleedList>}
        {segmentMatches.size > 3 && <div className={styles.expandlink}>
          <a onClick={() => this.toggleExpanded()}>{expanded ? 'Collapse Segments' : 'Show All Segments'}</a>
        </div>}
        {segmentMatches.size === 0 && objectType === 'route' && <div>
          <p>There are no segments for this {objectType}. Visit our <a href='https://ridewithgps.com/help/segments' target='_blank'>help page</a> to learn how to create segments for a {objectType}.</p>
        </div>}
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  segmentMatches: segmentMatchSelectors.segmentsForParent(state, ownProps.objectType, ownProps.troute.id)
})

export const TRouteSegments = connect(
  mapStateToProps,
  null
)(_TRouteSegments)
